// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { CSSProperties } from 'react';

const colors = {
  bg: '#FAFAF9',
  border: '#E7E5E4',
  textPrimary: '#1C1917',
  textSecondary: '#78716C',
  dot: '#00D2AA',
  /** Brand primary (matches reference Read Me button) */
  brandPrimary: '#00D2AA'
} as const;

export const headerRoot: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '10px 5px 0 5px',
  // backgroundColor: colors.bg,
  minHeight: 64,
  boxSizing: 'border-box'
};

export const headerLeft: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 8
};

export const statusDot: CSSProperties = {
  width: 8,
  height: 8,
  borderRadius: '50%',
  backgroundColor: colors.dot,
  flexShrink: 0
};

export const titleText: CSSProperties = {
  fontSize: 14,
  fontWeight: 600,
  letterSpacing: '0.08em',
  color: colors.textPrimary,
  margin: 0,
  textTransform: 'uppercase'
};

export const headerRight: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  marginLeft: 'auto'
};

export const userInfo: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end'
};

export const userName: CSSProperties = {
  fontSize: 14,
  fontWeight: 600,
  color: colors.textPrimary,
  margin: 0,
  lineHeight: 1.3
};

export const userRole: CSSProperties = {
  fontSize: 11,
  fontWeight: 500,
  color: colors.textSecondary,
  margin: 0,
  lineHeight: 1.3,
  textTransform: 'uppercase',
  letterSpacing: '0.02em'
};

export const headerAvatar: CSSProperties = {
  width: 40,
  height: 40,
  borderRadius: '50%',
  backgroundColor: '#D6D3D1',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 16,
  fontWeight: 600,
  color: '#44403C',
  flexShrink: 0,
  cursor: 'pointer'
};

/** Read Me button – matches reference Header styling (pill, brand color, hover) */
export const readmeButtonWrapper: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 6
};

export const readmeButton: CSSProperties = {
  height: 32,
  padding: '0 10px',
  borderRadius: 999,
  border: 'none',
  background: 'rgba(0, 0, 0, 0.04)',
  color: colors.brandPrimary,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 6,
  cursor: 'pointer',
  transition: 'background 0.15s ease, transform 0.15s ease'
};

export const readmeButtonLabel: CSSProperties = {
  fontSize: 14,
  whiteSpace: 'nowrap' as const,
  color: colors.brandPrimary,
  fontWeight: 500,
  fontFamily: 'G42 Sans'
};

/** Apply on hover (merge with readmeButton in component) */
export const readmeButtonHover: CSSProperties = {
  background: 'rgba(0, 0, 0, 0.08)',
  transform: 'translateY(-1px)'
};
